const resources = {
    exclusiveOffers: 'Exclusive Offers'
};

export default function getResource(label) {
    return resources[label];
}
